import { useSelector } from 'react-redux';
import { selectFeatureFlags } from 'core/userContext';
import { DCB_IN_BEE_EDITOR } from 'modules/dynamicContentBuilder/featureFlags';
import { DYNAMIC_CONTENT_BUILDER_ADDON_HANDLE } from '../constants';

export const useDynamicContentBuilderAddOn = () => {
  const { [DCB_IN_BEE_EDITOR]: isDynamicContentBuilderEnabled = false } =
    useSelector(selectFeatureFlags);

  return {
    id: DYNAMIC_CONTENT_BUILDER_ADDON_HANDLE,
    enabled: isDynamicContentBuilderEnabled,
  };
};
